import { Facebook, Mail, Pinterest, Twitter, WhatsApp } from "@mui/icons-material";
import React, { useEffect, useRef } from "react";

export default function ShareModal({ url, onClose, open }) {
    const modalRef = useRef(null);

    useEffect(() => {
        function handleClickOutside(event) {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                onClose();
            }
        }
        if (open) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [onClose, open]);

    const copyToClipboard = async () => {
        await navigator.clipboard.writeText(url);
        alert("Link copied to clipboard!");
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
            <div ref={modalRef} className="bg-white rounded-2xl shadow-lg p-6 w-96 relative">

                {/* Close Button */}
                <button
                    onClick={onClose}
                    className="absolute top-2 right-4 text-gray-600 hover:text-black hover:bg-white"
                >
                    ✕
                </button>

                <h2 className="text-lg font-semibold mb-4">Share with</h2>

                {/* Social Buttons */}
                <div className="flex justify-around mb-4">
                    <a
                        href={`https://wa.me/?text=${encodeURIComponent(url)}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <WhatsApp size={50} className="text-green-500" />
                    </a>

                    <a
                        href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Facebook size={50} className="text-blue-600" />
                    </a>

                    <a
                        href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Twitter size={50} className="text-sky-500" />
                    </a>

                    <a
                        href={`https://pinterest.com/pin/create/button/?url=${encodeURIComponent(url)}&media=${encodeURIComponent(url)}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Pinterest size={50} className="text-red-500" />
                    </a>

                    <a
                        href={`mailto:?subject=Check this product&body=${encodeURIComponent(url)}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Mail size={50} className="text-gray-600" />
                    </a>
                </div>

                <h3 className="text-sm font-medium mb-2">Or share with link</h3>

                {/* Copy Link */}
                <div className="flex items-center border rounded-md p-2">
                    <input
                        type="text"
                        value={url}
                        readOnly
                        className="flex-grow text-sm text-gray-600 outline-none"
                    />
                    <button
                        onClick={copyToClipboard}
                        className="ml-2 px-3 py-1 bg-gray-200 rounded hover:bg-gray-300 text-sm"
                    >
                        Copy
                    </button>
                </div>
            </div>
        </div>
    );
}
